module.exports = __webpack_public_path__ + "img/IBC-Hotel-Web-Logo1-768x682.802faf5f.png";